import { GroupClients } from '@ms/yammer-graphql';
import { normalize } from 'normalizr';

import { groupSchema } from './schemas/group';
import { NormalizedGroup } from './types';

type GroupNormalizer = (response: { readonly data: GroupClients }) => NormalizedGroup;

export const normalizeGroup: GroupNormalizer = (response) => {
  const { entities, result } = normalize(response, { data: { group: groupSchema } });

  return { entities, result: result.data.group };
};
